<h1 mat-dialog-title>Terms Of Use</h1>
<div mat-dialog-content>
  <zwi-terms-of-use></zwi-terms-of-use>
</div>
